<template>
  <ModalWrapper modal-container-class="w-auto p-0 bg-black bg-opacity-95">
    <div class="flex flex-col items-center justify-center flex-1 gap-3 p-10">
      <div class="text-lg text-white font-replica-pro">
        <input
          readonly
          :value="video.podcast_url"
          class="h-auto text-lg md:min-w-[420px] text-white bg-transparent border-0 font-replica-pro focus:ring-0"
        />
        <IconsCopyclipboard
          class="inline-block w-4 h-4 cursor-pointer"
          icon-id="clip0_1071_18978"
          @click="copyClipboardText()"
        />
      </div>
      <ul class="flex items-center gap-4">
        <li>
          <WhatsAppIcon
            class="w-10 h-10 transition-all cursor-pointer hover:scale-110"
            @click="shareOnWhatsApp"
          />
        </li>
        <li>
          <FacebookIcon
            class="w-10 h-10 transition-all cursor-pointer hover:scale-110"
            @click="shareOnFacebook"
          />
        </li>
        <li>
          <XIcon
            class="w-10 h-10 text-white transition-all cursor-pointer hover:scale-110"
            @click="shareOnTwitter"
          />
        </li>
        <li>
          <img
            src="~/assets/images/insta.png"
            class="w-10 h-10 transition-all cursor-pointer hover:scale-110"
            @click="shareToInstagram"
          />
        </li>
        <li>
          <img
            src="~/assets/images/ticktok.png"
            class="w-10 h-10 transition-all cursor-pointer hover:scale-110"
            @click="shareToTikTok"
          />
        </li>
      </ul>
    </div>
  </ModalWrapper>
</template>
<script setup>
import WhatsAppIcon from "@/assets/svg/floating/whatsapp.svg?component";
import FacebookIcon from "@/assets/svg/floating/facebook.svg?component";
import XIcon from "@/assets/svg/floating/x.svg?component";
import { useTranslation } from "i18next-vue";

const props = defineProps({
  video: {
    type: Object,
    required: true,
  },
});

const nuxtApp = useNuxtApp();
const { t } = useTranslation();

async function copyClipboardText() {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(props.video.podcast_url);
    }

    nuxtApp.$toast.success(t("common.copied_clipboard"));
  } catch (e) {
    console.error(e);
  }
}
// Facebook share
function shareOnFacebook() {
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    props.video.podcast_url
  )}`;
  window.open(facebookUrl, "_blank", "width=600,height=400");
}

// Twitter share
function shareOnTwitter() {
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    props.video.podcast_url
  )}&text=${encodeURIComponent(props.video.youtube_details.title)}`;
  window.open(twitterUrl, "_blank", "width=600,height=400");
}

// LinkedIn share
function shareOnLinkedIn() {
  const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    props.video.podcast_url
  )}&title=${encodeURIComponent(props.video.youtube_details.title)}`;
  window.open(linkedinUrl, "_blank", "width=600,height=400");
}

// WhatsApp share
function shareOnWhatsApp() {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
    props.video.youtube_details.title
  )}%20${encodeURIComponent(props.video.podcast_url)}`;
  window.open(whatsappUrl, "_blank", "width=600,height=400");
}
//  Instagram Share
function shareToInstagram() {
  const instagramShareUrl = `https://www.instagram.com/?url=${encodeURIComponent(
    props.video.youtube_details.title
  )}%20${encodeURIComponent(props.video.podcast_url)}`;
  window.open(instagramShareUrl, "_blank", "width=600,height=400");
}

//  TikTok Share
function shareToTikTok() {
  const instagramShareUrl = `https://www.tiktok.com/share/video?url=${encodeURIComponent(
    props.video.youtube_details.title
  )}%20${encodeURIComponent(props.video.podcast_url)}`;
  window.open(instagramShareUrl, "_blank", "width=600,height=400");
}
</script>
